<template>
  <section :class="['card-wrapper', isMobile ? '' : 'desktop']">
    <div
      :class="[
        'card-item',
        displayModeClassName,
        'flex-col-center',
        active === item.id ? 'active' : '',
      ]"
      @click="packageClick(item)"
    >
      <div class="account-balance flex-col-center">
        <p class="amount flex-center">
          {{ item.originalPrice | formatNumber(region) }}
          <img :src="require(`@/assets/images/wallet/T-coin.png`)" />
        </p>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import priceFormatMixins from '@/mixins/wallet/priceFormat'

  export default {
    name: 'card-item',
    mixins: [priceFormatMixins],
    computed: {
      ...mapState(['isMobile', 'region']),
      ...mapGetters(['displayModeClassName']),
    },
    props: {
      item: {
        default: () => {},
        type: Object,
      },
      active: {
        default: 1,
        type: Number,
      },
    },
    filters: {},
    methods: {
      packageClick(item) {
        if (item.active) {
          return
        }
        this.$emit('selectPackage', item)
      },
    },
  }
</script>

<style scoped lang="scss">
  .card-wrapper {
    width: 50%;
    padding: 12px;
    box-sizing: border-box;

    .card-item {
      background: #ffffff;
      box-sizing: border-box;
      border: 1px solid #d7d7d7;
      border-radius: 12px;
      min-width: 312px;
      height: 192px;
      font-family: Manrope-Medium, Manrope;
      position: relative;
      .account-balance {
        height: 100%;
      }
      &.active {
        border: 2px solid rgba(249, 96, 0, 1);
        background: rgba(249, 96, 0, 0.05);
        &::after {
          content: '';
          background: url('~@/assets/images/wallet/selected_icon.png') top /
            cover;
          position: absolute;
          top: 0;
          right: 0;
          width: 96px;
          height: 90px;
          backdrop-filter: blur(0px);
        }
      }
      .amount {
        font-weight: 600;
        font-size: 66px;
        line-height: 88px;
        color: rgba(249, 96, 0, 1);
        & > img {
          margin-left: 13px;
          height: 66px;
          object-fit: contain;
        }
      }
      .desc {
        margin-top: 21px;
        font-size: 16px;
        line-height: 25px;
        color: rgba(0, 0, 0, 0.4);
      }
      &.display-desktop {
        justify-content: unset;
      }
    }
  }
</style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './cardItem_pc.scss';
  }
</style>
